import { apiWithkey } from "../axios";
import {
  baseApiURL,
  getCategoriaApi,
  plansApi,
  planDetailsApi,
} from "../endpoints";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../utils/setLoadingMessage";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useUserStore from "../../storeModules/useUserStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import sleepAwait from "../../utils/sleepAwait";
import findStep from "../../screens/bot/stepModules/findStep";
import DatadogErrorReporter from "../../utils/datadogErrorReporter";
import GetPlansError from "../../utils/customErrors/getPlansError";
import getRendaQualificada from "../../utils/getRendaQualificada";

const fakeLoad = useInitialConfigStore.getState().fakeLoad;

const getPlanCategoria = async () => {
  setLoadingMessage();

  try {
    const empresaID = useInitialConfigStore.getState().empresaId;
    const url = `${baseApiURL}${getCategoriaApi}?empresaID=${empresaID}`;

    const response = await apiWithkey.get(url);
    const { data } = response.data;

    if (data && Array.isArray(data) && data.length > 0) {
      useConsorcioStore.setState((state) => ({
        ...state,
        fetchedCategorias: data,
      }));

      return data;
    } else {
      console.warn("Nenhum dado de categoria retornado pela API.");
    }
  } catch (_) {
    useInitialConfigStore.setState({
      currentStep: findStep("erro_geral").index,
    });
  } finally {
    removeLoadingMessage();
  }
};

const getPlans = async () => {
  setLoadingMessage();

  const url = `${baseApiURL}${plansApi}`;

  const { empresaId } = useInitialConfigStore.getState();
  const { categoriaId } = useConsorcioStore.getState();
  const basicData = useUserStore.getState().basic;
  const { LeadID } = useUserStore.getState().lead;

  const props = {
    categoriaId,
    empresaId,
    valorCredito: basicData.valorCredito,
    leadID: LeadID,
    valorParcelaIdeal: getRendaQualificada(basicData) * 0.3,
  };

  return apiWithkey
    .post(url, props)
    .then(async (response) => {
      const fetchedPlans = response.data.data.planos;

      const consorcioData = useConsorcioStore.getState();

      if (fetchedPlans.length) {
        useConsorcioStore.setState({
          ...consorcioData,
          fetchedPlans,
        });

        await sleepAwait(fakeLoad);

        useBotControlStore.setState({
          currentStep: findStep("selecao_planos").index,
        });
      }
    })
    .catch((error) => {
      DatadogErrorReporter.reportApiError(new GetPlansError(error, url, props));
      if (
        error?.response?.data?.errors?.includes(
          "Não foram encontrados planos para esta empresa",
        )
      ) {
        useBotControlStore.setState({
          currentStep: findStep("erro_sem_planos").index,
        });
      } else if (
        error?.response?.data?.errors?.includes(
          "Não foram encontrados planos para sua renda",
        )
      ) {
        useBotControlStore.setState({
          currentStep: findStep("erro_renda_insuficiente").index,
        });
      } else {
        useBotControlStore.setState({
          currentStep: findStep("erro_geral").index,
        });
      }
    })
    .finally(() => {
      removeLoadingMessage();
    });
};

const getPlanDetails = async () => {
  const url = `${baseApiURL}${planDetailsApi}`;

  const { planoID, bemID } = useConsorcioStore.getState().selectedPlano;
  const { LeadID } = useUserStore.getState().lead;
  const { empresaId } = useInitialConfigStore.getState();

  const props = {
    empresaID: empresaId,
    leadID: LeadID,
    planoID: planoID,
    bemID: bemID,
  };

  return apiWithkey.post(url, props);
};

export { getPlanCategoria, getPlans, getPlanDetails };
